export default __webpack_public_path__ + "static/media/jamaica.903ecc3b.png";